import IconToolTip from "@/Components/Icon/IconToolTip";
import useCommon from "@/shared/hooks/useCommon";
import useElectronHook from "@/shared/hooks/useElectronHook";

const ElectronReload = () => {
  const t = useCommon();
  const { isElectron } = useElectronHook();
  return (
    isElectron && (
      <div onClick={() => window.location.reload()} className="font-semibold">
        <IconToolTip
          text={t("orders_live.reloadThePage")}
          variants="sync"
          className="fill-text"
        />
      </div>
    )
  );
};

export default ElectronReload;
